import { useContext, useEffect, useState } from "react";

export const useShippingDetailHeader = (props) => {
    return {};
};
